import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-add-rate-product',
  templateUrl: './add-rate-product.component.html',
  styleUrls: ['./add-rate-product.component.css']
})
export class AddRateProductComponent implements OnInit {
  isActive2='1'
  isActive='1'
  rateAmount=0
  constructor (
    private http: HttpClient,
    private auten: AuthenticationService,
    public dialogRef: MatDialogRef<AddRateProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick (): void {
    this.dialogRef.close()
  }

  ngOnInit (): void {}

  onaddRateAmountProduct () {
    var request = {
      idproduct: Number(this.data.Id),
      item: String(this.data.ItemNumber),
      itemdescription: String(this.data.ItemDescription),
      rateamount: Number(this.rateAmount),
      active: Number(this.isActive),
      typeRate: Number(this.isActive2)
    }
    this.http
      .post<any>(`${environment.apiUrl}/Products/RateProductsInsert`, request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + this.auten.currentUserValue.token
        })
      })
      .subscribe(() => {

        this.onNoClick()
      })
  }
}
